import Indicador from "..";
import IMVEditFields from "./components/IMVEditFields";
import { IMVParamFields } from "./components/IMVParamFields";
import imvReport from "./reports";
import imvReportSummary from "./reports/summary";

export default class IMV extends Indicador {
    static get fullName() {
        return "Impureza Vegetal";
    }

    static get abbrev() {
        return "IMV";
    }

    static paramFields(tipoIndicadorField = '') {
        return <IMVParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <IMVEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return imvReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return imvReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas
            || !params
            || apontamento.coletas.length === 0
        ) {
            return 0;
        }

        const total = apontamento.coletas.length;
        apontamento.totalImpureza = 0;
        apontamento.impurezaVegetal = 0;
        apontamento.pesoPalhaPc = 0
        apontamento.pesoPalmitoPc = 0

        for (const coleta of apontamento.coletas) {
            if (f(coleta.pesoTotal) && f(coleta.pesoPalhaKg)) {
                coleta.pesoPalhaPc = ((f(coleta.pesoPalhaKg) * 100) / f(coleta.pesoTotal)).toFixed(2)
                apontamento.totalImpureza += f(coleta.pesoPalhaKg)
                apontamento.pesoPalhaPc += f(coleta.pesoPalhaPc)
            }

            if (f(coleta.pesoTotal) && f(coleta.pesoPalmitoKg)) {
                coleta.pesoPalmitoPc = ((f(coleta.pesoPalmitoKg) * 100) / f(coleta.pesoTotal)).toFixed(2)
                apontamento.totalImpureza += f(coleta.pesoPalmitoKg)
                apontamento.pesoPalmitoPc += f(coleta.pesoPalmitoPc)
            }
        }

        apontamento.impurezaVegetal = (f(apontamento.pesoPalhaPc) + f(apontamento.pesoPalmitoPc)).toFixed(3);

        return apontamento.impurezaVegetal;
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatusInverte(conformidade, meta, 117.05, 100, 83.61);
    }

    static getResultStr(apontamento) {
        return "Total Impureza: " + apontamento.totalImpureza +
            "e Impureza Vegetal (%): " + apontamento.impurezaVegetal
    }
}
